import { Component, OnInit, inject } from '@angular/core';
import { DocumentPageBase } from '../../shared/components/document-page-base/document-page-base';
import { MatDialog } from '@angular/material/dialog';
import { WebdokuService } from '../../web-doku/webdoku.service';
import { LdwRouterService } from '../../route/ldw-router.service';
import { DocumentService } from '../../shared/services/document.service';
import { InfoService } from '../../shared/services/info.service';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { BookmarkService } from '../../bookmarks/bookmark.service';
import { SettingsService } from '../../shared/settings/settings.service';

@Component({
    selector: 'ldw-document-view-page',
    templateUrl: './document-view-page.component.html',
    styleUrls: ['./document-view-page.component.css'],
    standalone: false
})
export class DocumentViewPageComponent extends DocumentPageBase implements OnInit {
  private settingsService = inject(SettingsService);

  isAndroidAppDocumentMode = true;

  constructor() {
    const dialog = inject(MatDialog);
    const routerService = inject(LdwRouterService);
    const webDokuService = inject(WebdokuService);
    const documentService = inject(DocumentService);
    const translate = inject(TranslateService);
    const infoService = inject(InfoService);
    const route = inject(ActivatedRoute);
    const bookmarkService = inject(BookmarkService);

    super(dialog, routerService, webDokuService, documentService, translate, infoService, route, bookmarkService);
  }


  override close() {

    // hack does NOT work with Firefox
    // @ts-ignore
    // window && window.open('','_self').close()
    if (this.settingsService.IsRunningInWindowModeAndOpenInNewTabMode()) {

      this.routerService.navigateClose();
      return;
    }
    this.routerService.canNavigateBack ? this.routerService.navigateBack() : this.routerService.navigateToDocumentsRoot();
  }
}
